<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Nieprawidłowy numer plomby'" class="text-center" />
        </template>

        <page-preloader v-if="isLoading" min-height="200px" />

        <div v-else class="text-center p-3">
            <a-icon
                icon="WarningFull"
                width="2.5rem"
                height="2.5rem"
                class="text-warning"
            />

            <h5 v-html="detailsText" class="font-weight-normal my-3" />
            <h5 class="font-weight-normal text-orange pt-3">
                {{ warningText }}
                <strong v-if="!isSealNumberUnknown">{{ sealNumber }} ?</strong>
            </h5>
        </div>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Nie, wróć"
                :disabled="isLoading"
                @click="args.onRejectBtn(args)"
            />
            <the-btn
                class="btn-danger"
                text="Tak, kontynuuj"
                :disabled="isLoading"
                @click="onAccept"
            />
        </template>
    </ui-modal>
</template>

<script>
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'

export default {
    mixins: [bagsMixin],

    data: () => ({
        isLoading: false
    }),

    computed: {
        args() {
            return this.$store.getters.getModal.args
        },

        bag() {
            return this.args.bag
        },

        sealNumber() {
            return this.args.sealNumber
        },

        currentSealPrefix() {
            return this.sealNumber.slice(0, 2)
        },

        preferredOperator() {
            return this.bag.preferredOperator || {}
        },

        detailsText() {
            return this.isSealNumberUnknown
                ? `Wprowadzony numer plomby nie jest powiązany z żadnym operatorem.
                    <br/>Taki worek możesz wydać jedynie transportem własnym.`
                : `Przedrostek plomby (${this.currentSealPrefix}) nie należy do
                    preferowanego operatora dla tej frakcji.<br/>
                    Plomba operatora ${this.preferredOperator.name} zaczyna się od ${this.preferredOperator.prefix}`
        },

        warningText() {
            return this.isSealNumberUnknown
                ? 'Czy chcesz kontynuować?'
                : 'Czy na pewno chcesz kontynuować z numerem plomby'
        }
    },

    methods: {
        async onAccept() {
            this.isLoading = true

            await this.args.onAcceptBtn()

            this.isLoading = false
            this.$emit('close-modal')
        }
    }
}
</script>